import React, { useContext } from 'react'

export const FilterContext = React.createContext<{
  productCurrencyCode?: string
}>({
  productCurrencyCode: undefined,
})

export const useFilterContext = () => useContext(FilterContext)
